import { render, staticRenderFns } from "./HeroSplit.vue?vue&type=template&id=22ea27cc&"
import script from "./HeroSplit.vue?vue&type=script&lang=js&"
export * from "./HeroSplit.vue?vue&type=script&lang=js&"
import style0 from "./HeroSplit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports